export default __webpack_public_path__ + "static/media/Avatar-4.ad9af983.png";